import { Swiper, Navigation, Pagination, Mousewheel } from "swiper";
import { isMobile, getNumberId } from "../common/utils";

const showModalSnap = (snapId) => {
  const snap = window.fstore.mediaCache.snaps.find((snap) => snap.articleId == snapId);
  if (!snap) {
    return;
  }
  const modal = document.querySelector("#modal-2023-snap");
  const content = modal.querySelector(".fs-modal-content");
  renderSnap(snap, content);

  content.addEventListener("click", hideModalSnap);
  modal.classList.add("show");
  document.querySelector("html").classList.add("overflow-hidden");
  setTimeout(() => {
    content.classList.add("show");
  }, 100);
};

const hideModalSnap = () => {
  const modal = document.querySelector("#modal-2023-snap");
  const content = modal.querySelector(".fs-modal-content");
  content.removeEventListener("click", hideModalSnap);
  content.classList.remove("show");
  setTimeout(() => {
    modal.classList.remove("show");
    document.querySelector("html").classList.remove("overflow-hidden");
  }, 500);
};

const renderSnap = (snap, element) => {
  const items = snap.items.map((item) => `<li>${item.key}: ${item.value}</li>`).join("");
  const html = `
    <button class="fs-close-button"></button>
    <div class="fs-snap-container">
      <div class="fs-snap">

        <div class="fs-content">

          <div class="fs-image">
            <img src="${snap.image.url.replace("width=1500", "width=750")}" alt="" />
            <div class="fs-overlay"></div>
          </div>

          <div class="fs-texts">
            <p>Model : ${snap.model.name} / Age : ${snap.model.age}</p>
            <ul>${items}</ul>
            <a href="https://www.fashionsnap.com${snap.permalink}" target="_blank" class="fs-button"><span>スナップを見る</span></a>
          </div>

        </div>

        <div class="fs-products"></div>
      </div>
    </div>
  `;
  element.innerHTML = html;

  if (!snap.productIds || snap.productIds <= 0) {
    showContainer();
    return;
  }

  const productsElement = element.querySelector(".fs-products");
  window.ShopifyClient.fetchProducts(snap.productIds)
    .then((products) => {
      renderProducts(products, productsElement);
    })
    .catch((error) => {
      /* console.error(error) */
    });
};

const renderProducts = (products, element) => {
  const productsHtml = products
    .map((product) => {
      let img = "";
      if (product.images?.edges?.[0]?.node.url) {
        img = `<img src="${product.images?.edges?.[0]?.node.url}&width=320" />`;
      }

      let price = product.priceRange.minVariantPrice.amount;
      let compareAtPrice = !product.compareAtPriceRange
        ? null
        : parseInt(product.compareAtPriceRange.minVariantPrice.amount);
      let priceText = `<p class="fs-price">&yen; ${new Intl.NumberFormat("ja-JP").format(price)}</p>`;
      if (compareAtPrice && price != compareAtPrice) {
        let discountRate = ((1.0 - price / compareAtPrice) * 100.0).toString().split(".")[0];
        priceText += ` <p class="fs-original-price">&yen;${new Intl.NumberFormat("ja-JP").format(compareAtPrice)}</p>`;
        priceText += ` <p class="fs-discount-rate">(${discountRate}%OFF)</p>`;
      }

      const salesTypes = !product.sales_type ? [] : product.sales_type.value.split(",");
      const coupon = product.tags.includes("クーポン対象");
      const campaign = product.tags.includes("キャンペーン対象");
      const restock = product.tags.includes("再入荷");

      let soldout = false;
      if (
        !product.tags.includes("coming soon") &&
        !product.tags.includes("COMING SOON") &&
        product.totalInventory == 0
      ) {
        soldout = true;
      }

      return `
      <div class="swiper-slide">
        <a href="/products/${product.handle}">
          <div class="fs-product" data-product-id="${getNumberId(product.id)}">
            <div class="fs-image">
              ${img}
            </div>
            <div class="fs-texts">
              <p class="fs-vendor">${product.vendor}</p>
              <p class="fs-name">${product.title}</p>
              <div class="fs-price-row">${priceText}</div>
              <div class="fs-badges">
                ${salesTypes.includes("セール商品") ? '<div class="fs-badge sale">SALE</div>' : ""}
                ${salesTypes.includes("予約商品") ? '<div class="fs-badge presale">予約商品</div>' : ""}
                ${restock ? '<div class="fs-badge restock">再入荷</div>' : ""}
                ${product.totalInventory == 1 ? '<div class="fs-badge stock">残り1点</div>' : ""}
                ${soldout ? '<div class="fs-badge soldout">SOLD OUT</div>' : ""}
                ${coupon ? '<div class="fs-badge sale">クーポン対象</div>' : ""}
                ${campaign ? '<div class="fs-badge sale">キャンペーン対象</div>' : ""}
                ${product.tags.includes("洗える") ? '<div class="fs-badge presale">洗える</div>' : ""}
                ${product.tags.includes("記事掲載") ? '<div class="fs-badge presale">記事掲載</div>' : ""}
                ${product.tags.includes("スナップ着用") ? '<div class="fs-badge presale">スナップ着用</div>' : ""}
                ${product.tags.includes("コラボアイテム") ? '<div class="fs-badge presale">コラボアイテム</div>' : ""}
                ${product.tags.includes("別注アイテム") ? '<div class="fs-badge presale">別注アイテム</div>' : ""}
              </div>
            </div>
          </div>
        </a>
      </div>
    `;
    })
    .join("");

  const html = `
    <div class="fs-products-content">
      <div class="swiper">
        <div class="fs-swiper-header">
          <h4>関連アイテム</h4>

          <div class="swiper-pagination"></div>

          <div class="fs-navigation-buttons">
            <div class="swiper-navigation-prev"></div>
            <div class="swiper-navigation-next"></div>
          </div>
        </div>

        <div class="swiper-wrapper">
          ${productsHtml}
        </div>
      </div>
    </div>
  `;

  element.innerHTML = html;
  setupSwiper(element);
};

const setupSwiper = (element) => {
  const offset = isMobile() ? 20 : 0;
  const swiperElement = element.querySelector(".swiper");
  const _ = new Swiper(swiperElement, {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 1.4,
    spaceBetween: 8,
    slidesOffsetBefore: offset,
    slidesOffsetAfter: offset,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      sensitivity: 0.1,
      thresholdDelta: 10,
    },
    navigation: {
      nextEl: ".swiper-navigation-next",
      prevEl: ".swiper-navigation-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 2.2,
      },
    },
    watchOverflow: true,
    on: {
      init: () => {
        showContainer();
      },
      resize: (instance) => {
        if (instance.navigation.prevEl) {
          instance.navigation.prevEl.classList.toggle("hidden", instance.slides.length <= 2);
        }
        if (instance.navigation.nextEl) {
          instance.navigation.nextEl.classList.toggle("hidden", instance.slides.length <= 2);
        }
      },
      slidesLengthChange: (instance) => {
        setTimeout(() => {
          instance.updateSlides();
        }, 400);
      },
    },
  });
};

const showContainer = () => {
  const snapContainer = document.querySelector(".fs-snap-container");
  snapContainer.classList.add("show");
  snapContainer.querySelector(".fs-snap").addEventListener("click", (e) => e.stopPropagation());
};

const ModalSnap = () => {
  return {
    showModalSnap: showModalSnap,
    hideModalSnap: hideModalSnap,
  };
};

export default ModalSnap;
